export default "/images/vendor/flag-icon-css/flags/1x1/mf.svg?acdf197a05336d8cdb11d03dd120d7e2";